/**
 * Route for `campaign-spillover`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignSpilloverPage } from "../features/campaign-spillover/CampaignSpilloverPage";

export const campaignSpilloverRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-spillover",
	component: CampaignSpilloverPage,
});

export default campaignSpilloverRoute;
